import { apiClient } from './authenticatedApiClient';
import { IAflosschemadeel } from '@/model/IAflosschemadeel';
import { Guid } from 'guid-typescript';

export interface ICreateAflosschemasResponse {
  keyVoorBetaling: string;
  keyNaBetaling: string;
}

interface IGetAflosschemaResponse {
  aflosschemadelen: IAflosschemadeel[];
}

class AppAflosschemasService {
  public createAflosschemas(
    hypotheeknummer: string,
    hypotheekdeelnummer: string,
    aflossingsbedrag: number
  ): Promise<ICreateAflosschemasResponse> {
    const data = {
      id: Guid.createEmpty().toString(),
      hypotheeknummer,
      hypotheekdeelnummer,
      aflossingsbedrag
    };
    return apiClient.post<ICreateAflosschemasResponse>(`Aflosschemas`, data).then(response => {
      return response.data;
    });
  }

  public createAflosschema(hypotheeknummer: string): Promise<string> {
    return apiClient.post<string>(`Aflosschemas/${hypotheeknummer}`).then(response => {
      return response.data;
    });
  }

  public getAflosschema(id: string): Promise<IAflosschemadeel[]> {
    return apiClient.get<IGetAflosschemaResponse>(`Aflosschemas/${id}`).then(response => {
      return response.data.aflosschemadelen;
    });
  }
}

export const appAflosschemasService = new AppAflosschemasService();
